











































































































































































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { Country } from "../../types/country";
import { TitleMixin } from "../../services/mixins/titleMixin";
import { Application } from "../../types/application";
import {
  CreateClient,
  ClientScope,
  CreateWebAppClient
} from "../../types/client";
import DatePicker from "@/components/DatePicker.vue";
import { HttpService } from "@/services/api/httpService";
import { AxiosResponse, AxiosRequestConfig } from "axios";
import { SaveMixin } from "@/services/mixins/saveMixin";
import {
  required,
  email,
  numeric,
  minLength,
  maxLength,
  requiredUnless
} from "vuelidate/lib/validators";

import { ApiScope, ApiResource } from "../../types/apiResource";
import { isUrl } from "@/services/customValidator/customValidators";
import { IdentityResource } from "../../types/identityResource";
@Component({
  components: { DatePicker },
  validations: {
    client: {
      clientName: { maxLength: maxLength(200) },
      clientId: { required, maxLength: maxLength(200) },
      clientUri: { maxLength: maxLength(2000), isUrl },
      description: { maxLength: maxLength(1000) },
      logoUri: { maxLength: maxLength(2000), isUrl },
      backChannelLogoutUri: { maxLength: maxLength(2000), isUrl },
      frontChannelLogoutUri: { maxLength: maxLength(2000), isUrl },
      redirectUris: {
        $each: { redirectUri: { required, maxLength: maxLength(2000), isUrl } }
      },
      postLogoutRedirectUri: {
        $each: {
          postLogoutRedirectUri: { maxLength: maxLength(2000), isUrl }
        }
      },
      secret: {
        required,
        minLength: minLength(16),
        maxLength: maxLength(4000)
      },

      allowOfflineAccess: {}
    }
  },
  mixins: [SaveMixin, TitleMixin]
})
export default class ClientAddWebsite extends Vue {
  get title() {
    return "Add Client";
  }

  showData = false;
  scopes: (ApiResource | IdentityResource)[] = [];
  applications: Array<Application> = [];
  client = new CreateWebAppClient();
  newClientScope = new ClientScope();
  httpServiceCreateClient = new HttpService<CreateClient>();
  backRoute = {
    name: "clientList"
  };
  addClientScope() {
    if (this.newClientScope.scope == "") return; //if no scope selected return
    this.client.scopes.push(this.newClientScope);
    this.scopes.map((scope, index) => {
      if (scope.name == this.newClientScope.scope) {
        this.scopes.splice(index, 1);
      }
    });
    this.newClientScope = new ClientScope();
  }
  removeClientScope(scope: string, index: number) {
    this.client.scopes.splice(index, 1);
    let newScope = new ApiResource();
    newScope.name = scope;
    this.scopes.push(newScope);
  }

  async getApplications() {
    const httpService = new HttpService<Array<Application>>();
    const response = await httpService.getList("applications");
    this.applications = response.data;
    this.showData = true;
  }

  async getScopes() {
    const httpServiceAPI = new HttpService<Array<ApiResource>>();
    const apiResourceresponse = await httpServiceAPI.getList(
      "api-resources/1/scopes"
    );
    const httpServiveIdentity = new HttpService<Array<IdentityResource>>();
    const identityResourceResponse = await httpServiveIdentity.getList(
      "identity-resources"
    );
    const allScopes = [
      ...apiResourceresponse.data,
      ...identityResourceResponse.data
    ];

    const scopesAlreadyAdded = [
      new ClientScope("email"),
      new ClientScope("profile"),
      new ClientScope("openid")
    ]; //default Scopes for SPA and WebApp

    this.scopes = allScopes.filter(scope => {
      return !scopesAlreadyAdded.find(function removeScopesAlreadyAdded(
        scopeAddedAlready
      ) {
        return scope.name === scopeAddedAlready.scope;
      });
    });
  }

  async created() {
    await this.getScopes();
    this.getApplications();
  }
  async save() {
    this.$store.commit("SAVE", false);
    this.$v.$touch();

    //following is used because the server model doesn't recognise empty string, so instead should be a null
    let convertEmptyStringToNull = (str: string | null) =>
      str == "" ? null : str;

    this.client.backChannelLogoutUri = convertEmptyStringToNull(
      this.client.backChannelLogoutUri
    );
    this.client.frontChannelLogoutUri = convertEmptyStringToNull(
      this.client.frontChannelLogoutUri
    );
    this.client.logoUri = convertEmptyStringToNull(this.client.logoUri);

    if (!this.$v.$invalid) {
      const response = await this.httpServiceCreateClient.postItem(
        "webapp-client",
        this.client
      );

      this.$notification.success("Client details successfully saved");
      this.$store.dispatch("SET_DIRTY", false);

      this.$router.push({
        name: "clientDashboard",
        params: { id: response.data.id }
      });
    }
  }
}
